
import { useState } from "react";

const API_BASE =
  "https://td9dmwg0-8000.inc1.devtunnels.ms";

function Login({
  onRegister,
  onLoginSuccess
}) {
  const [email, setEmail] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    if (loading) {
      return;
    }

    setError("");
    setLoading(true);

    try {
      console.log("Starting login...");

      const response = await fetch(
        `${API_BASE}/auth/login`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },

          credentials: "include",

          body: JSON.stringify({
            email: email.trim(),
            password: password
          })
        }
      );

      console.log(
        "Login status:",
        response.status
      );

      let data = {};

      const contentType =
        response.headers.get(
          "content-type"
        ) || "";

      if (
        contentType.includes(
          "application/json"
        )
      ) {
        data = await response.json();
      } else {
        const text =
          await response.text();

        data = {
          detail: text
        };
      }

      console.log(
        "Login response:",
        data
      );

      // ==============================================
      // LOGIN FAILED
      // ==============================================

      if (!response.ok) {
        if (
          Array.isArray(
            data.detail
          )
        ) {
          const messages =
            data.detail
              .map((item) => {
                if (
                  typeof item ===
                  "string"
                ) {
                  return item;
                }

                return (
                  item?.msg ||
                  "Invalid request"
                );
              })
              .join(", ");

          setError(
            messages ||
            "Login failed"
          );
        } else {
          setError(
            data.detail ||
            data.message ||
            "Login failed"
          );
        }

        return;
      }

      // ==============================================
      // LOGIN SUCCESS
      // ==============================================

      console.log(
        "LOGIN SUCCESS"
      );

      /*
       * Login successful.
       *
       * Backend has already created
       * the authentication cookies.
       *
       * Do NOT call /auth/me here.
       */

      if (
        typeof onLoginSuccess ===
        "function"
      ) {
        onLoginSuccess();
        return;
      }

      console.error(
        "onLoginSuccess is missing!"
      );

      setError(
        "Login successful, but dashboard navigation is not configured."
      );

    } catch (error) {
      console.error(
        "Login error:",
        error
      );

      setError(
        "Unable to connect to server"
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleLogin}
    >
      <h2>
        Welcome Back
      </h2>

      <p className="subtitle">
        Login to continue
      </p>

      <label>
        Email
      </label>

      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) =>
          setEmail(e.target.value)
        }
        disabled={loading}
        required
      />

      <label>
        Password
      </label>

      <input
        type="password"
        placeholder="Enter your password"
        value={password}
        onChange={(e) =>
          setPassword(e.target.value)
        }
        disabled={loading}
        required
      />

      <button
        className="submit-btn"
        type="submit"
        disabled={loading}
      >
        {loading
          ? "Logging in..."
          : "Login"}
      </button>

      {error && (
        <p className="error-message">
          {error}
        </p>
      )}

      <p className="switch-text">
        Don't have an account?

        <span
          onClick={
            loading
              ? undefined
              : onRegister
          }
          style={{
            cursor:
              loading
                ? "default"
                : "pointer"
          }}
        >
          Register
        </span>
      </p>
    </form>
  );
}

export default Login;

